var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.850098 4.84998C0.850098 2.64084 2.64096 0.849976 4.8501 0.849976H14.8501C17.0592 0.849976 18.8501 2.64084 18.8501 4.84998V10.35C18.8501 12.5591 17.0592 14.35 14.8501 14.35H4.8501C2.64096 14.35 0.850098 12.5591 0.850098 10.35V4.84998Z",
    fill: "#FAE6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.85C0 2.17142 2.17142 0 4.85 0H14.85C17.5286 0 19.7 2.17142 19.7 4.85V10.35C19.7 13.0286 17.5286 15.2 14.85 15.2H4.85C2.17142 15.2 0 13.0286 0 10.35V4.85ZM4.85 1.7C3.1103 1.7 1.7 3.1103 1.7 4.85V10.35C1.7 12.0897 3.1103 13.5 4.85 13.5H14.85C16.5897 13.5 18 12.0897 18 10.35V4.85C18 3.1103 16.5897 1.7 14.85 1.7H4.85Z",
    fill: "#A51713"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2589 6.19535C10.3721 6.63876 9.32827 6.63876 8.44146 6.19535L5.23032 4.58978C4.81044 4.37984 4.29986 4.55003 4.08992 4.96991C3.87998 5.38979 4.05017 5.90036 4.47005 6.1103L7.6812 7.71588C9.04661 8.39858 10.6538 8.39858 12.0192 7.71588L15.2303 6.1103C15.6502 5.90036 15.8204 5.38979 15.6104 4.96991C15.4005 4.55003 14.8899 4.37984 14.4701 4.58978L11.2589 6.19535Z",
    fill: "#A51713"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon_email.80f0f071d9063eb4941dd562b252cee2.svg";
export { ForwardRef as ReactComponent };